<header>
  <app-navigation></app-navigation>
</header>
<main>
  <div class="main-container">
    <router-outlet></router-outlet>
  </div>
</main>
<app-footer></app-footer>
